import { Box } from "@mui/material";
// project import
import NavCard from "./NavCard";
import Navigation from "./Navigation";
import SimpleBar from "../../../../components/third-party/SimpleBar";
import { color } from "framer-motion";
import LogOut from "./LogOutCard";
import SidebarSpeedTest from "../../../../components/SidebarSpeedTest";

// ==============================|| DRAWER CONTENT ||============================== //

export default function DrawerContent() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1, height: '100%', overflow: 'hidden', backgroundColor: "#1677ff" }}>
      <Box sx={{ flexGrow: 1, minHeight: 0 }}>
        <SimpleBar
          sx={{
            height: '100%',
            backgroundColor: "#1677ff",
            "& .simplebar-content": {
              display: "flex",
              flexDirection: "column",
              color: "white",
            },
          }}
        >
          <Navigation />
          {/* <NavCard /> */}
          <LogOut />
        </SimpleBar>
      </Box>
      <SidebarSpeedTest />
    </Box>
  );
}
